import React from 'react';
import { DateFilterProps, FilterSectionProps } from '../../../types/typesVPO';
import { arrow } from '../../../ui-icons/icons';
import { DateRangePicker } from './DateRangePicker';
import { MonthYearRangePicker } from './MonthYearRangePicker'; 

interface DateRangeValue {
  startDate: string | null;
  endDate: string | null;
}

interface DateRangeFilterProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  startLabel?: string;
  disabled?: boolean;
  monthYearOnly?: boolean; 
}

export const FilterSection: React.FC<FilterSectionProps> = ({ title, isOpen, toggleOpen, children, onReset, showReset, disabled, disabledMessage }) => {
  const hasSelectedItems = title.includes('·');

  return (
    <div className='border-b'>
      <div className='p-5 flex justify-between items-center cursor-pointer' onClick={toggleOpen}>
        <div className='flex items-center gap-x-4 flex-1'>
          <div className='flex-1 '>
            <span className={`text-sm  ${isOpen ? 'text-black' : 'text-primary '} ${hasSelectedItems ? 'font-medium text-black' : 'font-normal'}`}>{title}</span>
          </div>
          <span className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>{arrow}</span>
        </div>
      </div>
      {isOpen && (
        <>
          {disabled ? (
            <div className='px-5 pb-5'>
              <div className='flex items-center justify-center h-20 bg-gray-100 rounded-md'>
                <span className='text-gray-500 text-sm text-center px-4'>{disabledMessage}</span>
              </div>
            </div>
          ) : (
            <>
              {children}
              {showReset && (
                <div className='px-5 pb-5'>
                  <div className='flex items-center cursor-pointer group gap-x-2 text-primary' onClick={onReset}>
                    <span className='text-xs text-[#637381] group-hover:underline'>Сбросить фильтры</span>
                    <svg width='10' height='10' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M7.9999 7.19998L1.8999 1.09998C1.6749 0.874975 1.3249 0.874975 1.0999 1.09998C0.874902 1.32498 0.874902 1.67497 1.0999 1.89997L7.1999 7.99998L1.0999 14.1C0.874902 14.325 0.874902 14.675 1.0999 14.9C1.3249 15.125 1.6749 15.125 1.8999 14.9L7.9999 8.79998L14.0999 14.9C14.3249 15.125 14.6749 15.125 14.8999 14.9C14.9999 14.8 15.0749 14.65 15.0749 14.5C15.0749 14.35 15.0249 14.2 14.8999 14.1L8.7999 7.99998L14.8999 1.89997C14.9999 1.79997 15.0749 1.64997 15.0749 1.49998C15.0749 1.34998 15.0249 1.19998 14.8999 1.09998C14.6749 0.874975 14.3249 0.874975 14.0999 1.09998L7.9999 7.19998Z'
                        fill='#637381'
                      />
                    </svg>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  value,
  onChange,
  startLabel = 'Период',
  disabled = false,
  monthYearOnly = false 
}) => {
  if (monthYearOnly) {
    return (
      <MonthYearRangePicker
        value={value}
        onChange={onChange}
        startLabel={startLabel}
        disabled={disabled}
      />
    );
  }
  return (
    <DateRangePicker
      value={value}
      onChange={onChange}
      startLabel={startLabel}
      disabled={disabled}
    />
  );
};

export const DateFilter: React.FC<DateFilterProps> = ({ startDate, endDate, onStartDateChange, onEndDateChange, startLabel = 'Дата от', endLabel = 'Дата до' }) => (
  <div className='px-5 pb-5'>
    <div className='mb-4'>
      <label className='block text-sm text-gray-700 mb-2'>{startLabel}</label>
      <input type='date' value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className='w-full p-2 border rounded-lg' />
    </div>
    <div>
      <label className='block text-sm text-gray-700 mb-2'>{endLabel}</label>
      <input type='date' value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className='w-full p-2 border rounded-lg' />
    </div>
  </div>
);